import { bopApi } from '@/lib/api/client';
import type { AssetFlow, ViewId } from '@/pages/treasury/flows/flow-types';

const FLOW_PATH = 'v1/funds/asset-flows';

export const getFundsAssetFlows = (viewId: ViewId, daysAgo: number) => bopApi.get(FLOW_PATH, { searchParams: { viewId, daysAgo } }).json<AssetFlow>();
